








import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = 'ZMDTL0230';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '本周推荐',
      path: `/${baseUrl}/weekNews`,
      id: 1,
    },
    {
      title: '镇长晒主题',
      path: `/${baseUrl}/townNews`,
      id: 2,
    },
    {
      title: '龙乡有好礼',
      path: `/${baseUrl}/giftNews`,
      id: 3,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '好景在龙乡 周末到铜梁',
      url: location.href,
      subtitle: ``,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '好景在龙乡 周末到铜梁',
        subtitle: ``,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    // const ret = await getBaseInfo();
    // console.log('ret::::::', ret);
    // this.baseInfo = ret.data;
    // // 添加pv统计
    // if (this.baseInfo.activityId) {
    //   this.$addPv(this.baseInfo.activityId);
    // }
  }
}
